<template>
   <div class="page">
      <div>
         NxtForm is down for maintenance.
         <br />
         Please try again later.
         <br />
         <br />
         <button class="page__refresh" @click="refreshPage">
            <span class="button__text"> Try again </span>
         </button>
      </div>
   </div>
</template>

<script>
export default {
   methods: {
      refreshPage() {
         window.location.reload();
      },
   },
};
</script>

<style scoped>
.page {
   display: flex;
   justify-content: center;
   flex-direction: column;
   align-items: center;
   height: 100vh;
   width: 100vw;
}

.page__refresh {
   background-color: var(--primaryColor);
   color: white;
   border: none;
   padding: 6px 10px;
   border-radius: 8px;
}
</style>

